module.exports = __webpack_public_path__ + "static/media/optimize-sponsorships-channel-measurement-attribution.fd94cf44.png";